import { LinearProgress } from '@mui/material'
import React,{useState,useEffect} from 'react'
import { useAppData } from '../../../../../context/AppDataContext'
import ProjectTaskForm from '../../tasks/components/ProjectTaskForm';
import TaskStatusForm from '../../tasks/components/TaskStatusForm';
import TaskDetails from '../../tasks/components/TaskDetails';
import { useAlert } from '../../../../../context/AlertContext';
import taskServices from '../../tasks/taskServices';


function ProjectTaskList({projectId,autoload=false}) {

    const [projectTaskList,setProjectTaskList] = useState(null);
    const {AppAlert} = useAlert();

    const getProjectTaskList = () =>{
        taskServices.getByProjectId(projectId).then(res=>{
            setProjectTaskList(res.data);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    useEffect(()=>{
        if(autoload){
            getProjectTaskList();
        }
    },[])
    
    

    return (
        <>
        {!projectTaskList &&  <button className='btn btn-outline-primary mt-2' onClick={getProjectTaskList}>View Task</button> }
            
        {projectTaskList &&    
            <div className='row'>
                <div className='col-md-12'>
                    <div className='card mt-2' >
                        <div className='card-header bg-dark text-white'>Tasks</div>
                        <ol className="list-group list-group-numbered rounded-0">
                            {projectTaskList?.map(projectTask=>
                            
                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto w-100">
                                        <div className='d-flex justify-content-between'>
                                            <div className="fw-bold"><TaskDetails taskId={projectTask.id} taskTitle={projectTask.title} /></div>
                                            <ProjectTaskForm callBack={getProjectTaskList} data={projectTask} projectId={projectId} />
                                            
                                        </div>
                                        
                                        <TaskStatusForm data={projectTask} callBack={getProjectTaskList} />
                                    
                                        
                                    </div>
                                </li>
                            )}
                            <div className="list-group-item "><ProjectTaskForm callBack={getProjectTaskList} projectId={projectId} /></div>
                        </ol>
                    </div>
                </div>
            </div>
        }
        </>
  )
}

export default ProjectTaskList